import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import * as actions from '../../../../../store/actions';
import { bindActionCreators } from 'redux';
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	TableSortLabel,
	Paper,
	IconButton,
	TablePagination,
	Tooltip
} from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import PeopleIcon from '@material-ui/icons/People';

const styles = (theme) => ({
	root: {
		width: '100%',
		marginTop: theme.spacing(5),
		overflowX: 'auto'
	},
	table: {
		minWidth: 700
	}
});

function stableSort(array, cmp) {
	const stabilizedThis = array.map((el, index) => [el, index]);
	stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	});
	return stabilizedThis.map((el) => el[0]);
}

function desc(a, b, orderBy) {
	if (b[orderBy] < a[orderBy]) {
		return -1;
	}
	if (b[orderBy] > a[orderBy]) {
		return 1;
	}
	return 0;
}

function getSorting(order, orderBy) {
	return order === 'desc'
		? (a, b) => desc(a, b, orderBy)
		: (a, b) => -desc(a, b, orderBy);
}

const TableAfiliations = (props) => {
	const {
		rowsPerPage,
		page,
		classes,
		actions,
		showBenefitsList,
		resultSearch,
		showMoreInformation,
		is_promoter
	} = props;

	const [order, setOrder] = useState('asc');
	const [orderBy, setOrderBy] = useState('');
	const [data, setData] = useState([]);

	const handleRequestSort = (event, property) => {
		setOrder(orderBy === property && order === 'desc' ? 'asc' : 'desc');
		setOrderBy(property);
	};

	const handleChangeRowsPerPage = (event) => {
		actions.searchRowsPerPage({ page: 0, rowsPerPage: event.target.value });
	};

	const handleChangePage = (event, page) => {
		actions.searchPages({ page });
	};

	useEffect(() => {
		if (data !== resultSearch) setData(resultSearch);
	}, [resultSearch]);

	return (
		<Paper className={`${classes.root} customer-paper`}>
			<style global jsx>
				{`
					.customer-paper {
						box-shadow: none !important;
						margin-top: 0 !important;
					}
					.customer-paper .customer-table .table-header th {
						font-weight: 600 !important;
						font-size: 12px !important;
						color: rgba(0, 0, 0, 0.54) !important;
					}
					.customer-paper .customer-table tbody tr:nth-child(odd) {
						background-color: #fafafa !important;
					}
					.customer-paper .customer-table tbody td {
						font-size: 14px !important;
						padding: 20px !important;
					}
					.customer-paper .customer-table tbody td:nth-child(1) {
						border-left: 1px solid #e6ebf1;
					}
					.customer-paper .customer-table tbody td:nth-last-child(1) {
						border-right: 1px solid #e6ebf1;
					}
				`}
			</style>
			<Table className={`${classes.table} customer-table`}>
				<TableHead>
					<TableRow className="table-header text-sm">
						<TableCell
							sortDirection={orderBy === 'first_name' ? order : false}
							align="left"
						>
							<TableSortLabel
								active={orderBy === 'first_name'}
								direction={order}
								onClick={(e) => handleRequestSort(e, 'first_name')}
							>
								Nombre y Apellido
							</TableSortLabel>
						</TableCell>

						<TableCell
							sortDirection={orderBy === 'created_at' ? order : false}
							align="left"
						>
							<TableSortLabel
								active={orderBy === 'created_at'}
								direction={order}
								onClick={(e) => handleRequestSort(e, 'created_at')}
							>
								Fecha de Invitación
							</TableSortLabel>
						</TableCell>

						{!is_promoter && (
							<>
								<TableCell
									sortDirection={orderBy === 'email' ? order : false}
									align="left"
								>
									<TableSortLabel
										active={orderBy === 'email'}
										direction={order}
										onClick={(e) => handleRequestSort(e, 'email')}
									>
										Email
									</TableSortLabel>
								</TableCell>

								<TableCell
									sortDirection={orderBy === 'kinship' ? order : false}
									align="left"
								>
									<TableSortLabel
										active={orderBy === 'kinship'}
										direction={order}
										onClick={(e) => handleRequestSort(e, 'kinship')}
									>
										Parentesco
									</TableSortLabel>
								</TableCell>
							</>
						)}

						<TableCell
							sortDirection={orderBy === 'status' ? order : false}
							align="left"
						>
							<TableSortLabel
								active={orderBy === 'status'}
								direction={order}
								onClick={(e) => handleRequestSort(e, 'status')}
							>
								Estatus
							</TableSortLabel>
						</TableCell>

						{!is_promoter && <TableCell align="left">Acciones</TableCell>}
					</TableRow>
				</TableHead>
				<TableBody className="table-cells text-sm">
					{Array.isArray(data) &&
						stableSort(data, getSorting(order, orderBy))
							.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
							.map((row) => (
								<TableRow key={row._id}>
									<TableCell>
										{row.first_name} {row.last_name}
									</TableCell>
									<TableCell>
										{row.created_at &&
											new Date(row.created_at).toLocaleDateString()}
									</TableCell>
									{!is_promoter && (
										<>
											<TableCell>{row.email}</TableCell>
											<TableCell>TITULAR</TableCell>
										</>
									)}

									<TableCell>
										{row.customers && row.customers.length > 0
											? 'Completada'
											: 'pendiente'}
									</TableCell>

									{!is_promoter && (
										<TableCell>
											<div className="flex">
												{row.customers && row.customers.length > 0 && (
													<Tooltip title="Ver beneficiarios">
														<IconButton
															key="list"
															aria-label="list"
															onClick={() => showBenefitsList(row.customers)}
														>
															<PeopleIcon className="text-gray-600" />
														</IconButton>
													</Tooltip>
												)}
												{row.customers &&
													row.customers.find(
														(customer) => customer.kinship === 'TITULAR'
													) && (
														<Tooltip title="Ver más">
															<IconButton
																key="ver"
																aria-label="ver"
																onClick={() => {
																	const titular = row.customers.find(
																		(customer) => customer.kinship === 'TITULAR'
																	);
																	showMoreInformation(titular._id);
																}}
															>
																<VisibilityIcon className="text-gray-600" />
															</IconButton>
														</Tooltip>
													)}
											</div>
										</TableCell>
									)}
								</TableRow>
							))}
				</TableBody>
			</Table>
			{Array.isArray(data) && data.length > 5 && (
				<TablePagination
					rowsPerPageOptions={[5, 10, 15, 20]}
					component="div"
					rowsPerPage={rowsPerPage}
					page={page}
					count={data.length}
					backIconButtonProps={{
						'aria-label': 'Siguiente'
					}}
					nextIconButtonProps={{
						'aria-label': 'Anterior'
					}}
					onChangePage={handleChangePage}
					onChangeRowsPerPage={handleChangeRowsPerPage}
				/>
			)}
			{/* <SnackBar openAlert={openAlert} messageAlert={messageAlert} handleClose={handleClose} /> */}
		</Paper>
	);
};

function mapStateToProps(state, props) {
	const page = state.search.get('page');
	const rowsPerPage = state.search.get('rowsPerPage');
	const isAlly =
		state.login.get('id_user') && parseInt(state.login.get('type')) === 100;
	const great_ally_id = state.login.get('great_ally_id');
	const no_aply_commission = state.login.get('no_aply_commission');
	return {
		page,
		rowsPerPage,
		isAlly,
		great_ally_id,
		no_aply_commission
	};
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}

export default withStyles(styles)(
	connect(mapStateToProps, mapDispatchToProps)(TableAfiliations)
);
